module.exports = __webpack_public_path__ + "static/media/ic_text.67c4dede.svg";